import { v4 as uuidv4 } from 'uuid';

export function TabContent(props = {}, childrenComponents = []) {
	return {
		componentName: 'TabContent',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
